import { useTranslation } from 'gatsby-plugin-react-i18next';
import { m } from 'framer-motion';

import Image from '../Atoms/Image';
import Link from '../Atoms/Link';
import { graphql, useStaticQuery } from 'gatsby';
import { CONTACT_ROUTE } from '../../utils/routes/const';

const InfoBoxes = () => {
  const { t } = useTranslation();
  const data = useStaticQuery(imagesQuery);

  return (
    <section className="py-12 px-4 lg:px-8 bg-gray max-w-screen-2xl w-full mx-auto">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <dl className="grid lg:grid-cols-3 grid-cols-1 gap-11">
          {
            infoboxesData.map((item, index) => (
              <m.dl
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1, transition: { duration: 1 } }}
                viewport={{ once: true }}
                key={`benefits-${index}`}
                className="border border-primary flex "
              >
                <dt>
                  <div className="flex items-center justify-center h-40 w-32">
                    <Image className="w-18 mr-8" src={data && data[item.icon] && data[item.icon].publicURL} alt={t(item.linkTitle)} />
                  </div>
                </dt>
                <dd className="mt-8 mb-8 text-base font-light text-gray-700">
                  {t(item.description)}
                  <div>
                    <Link to={item.url} className="mt-4 font-bold text-primary">{t(item.linkTitle)}</Link>
                  </div>
                </dd>
              </m.dl>
            ))
          }
        </dl>
      </div>
    </section>
  );
}

const imagesQuery = graphql`
query {
  documents: file(base: {eq: "documents.svg"}) {
    publicURL
  }
  badge: file(base: {eq: "badge.svg"}) {
    publicURL
  }
  questions: file(base: {eq: "questions.svg"}) {
    publicURL
  }
}
`

const infoboxesData = [
  {
    icon: 'documents',
    description: 'infoboxes.0.description',
    linkTitle: 'infoboxes.0.linkTitle',
    url: '',
  },
  {
    icon: 'badge',
    description: 'infoboxes.1.description',
    linkTitle: 'infoboxes.1.linkTitle',
    url: CONTACT_ROUTE,
  },
  {
    icon: 'questions',
    description: 'infoboxes.2.description',
    linkTitle: 'infoboxes.2.linkTitle',
    url: '/faq',
  },
]

export default InfoBoxes;
